/* global localStorage */
import intl from 'react-intl-universal'

import { contentCommentReducers } from './reducerTable'

export default ['$rootScope', 'storyService', 'toastr', ContentComment]

export const blankRx = /^[/r/s/n]{0,}$/

export const commentFactory = (obj = {}) => {
  const date = new Date()
  return {
    text: obj.text || '',
    email: obj.email || localStorage.getItem('arc.email') || 'dev@dev.com',
    user:
      obj.user ||
      localStorage.getItem('arc.displayName') ||
      'dev user lfkjajk fajd fk fk ds',
    date: obj.date || date,
  }
}

export const getElementAndIndex = (id, storyService) =>
  storyService.getStorySync().content_elements.reduce((acc, c, i) => {
    if ((c.additional_properties || {})._id === id) {
      acc.element = c
      acc.index = i
    } else if (((c.raw_oembed || {}).additional_properties || {})._id === id) {
      acc.element = c.raw_oembed
      acc.index = i
    }

    return acc
  }, {})

export function ContentComment(root, storyService, toastr) {
  let params = {}
  this.editingOrigin = false
  this.isOrigin = false
  this.currentHover = 1
  this.repliesExpanded = false
  this.isReplying = false
  this.focusedComment = -1
  this.forceHeight = 0
  this.$onInit = () => {
    // rc hotfix...need to fix inflation for drag/drop elements
    this.comments = this.comments || []
    const comment = (this.comments || [])[0] || { replies: [] }
    this.models = {
      origin: '',
      replies: (comment.replies || []).map((r) => ({
        ui: false,
        cache: '',
        // showing all replies or not
        expanded: false,
      })),
    }
    this.isOrigin = this.comments.length < 1
    params = getElementAndIndex(this._id, storyService)
  }
  // controls which comment is on top if they are layered
  this.setCurrentHover = (index) => {
    this.currentHover = index
  }
  this.replyHashKey = (a, b) => `${a}${b}`
  this.hasReplyEdit = (a, b) => {
    return !!this.models.replies[a]
  }
  // checks if origin comment email is same as current one
  this.canEdit = () => {
    return (
      this.comments[0].email === localStorage.getItem('arc.email') ||
      'dev@dev.com'
    )
  }
  this.hasReplies = () => {
    return (
      this.comments &&
      this.comments[0] &&
      this.comments[0].replies &&
      this.comments[0].replies.length > 0
    )
  }
  this.cancelOriginComment = () => {
    root.$broadcast('CONTENT_COMMENT', {
      ...params,
      _id: this._id,
      type: 'ORIGIN_COMMENT_CANCEL',
    })
  }
  this.saveOriginComment = () => {
    // cannot be blank, causes issues with empty origin comment bug
    if (blankRx.test(this.models.origin)) {
      return toastr.error(intl.get('contentComment.saveOriginComment.error'))
    }
    root.$broadcast('CONTENT_COMMENT', {
      ...params,
      _id: this._id,
      type: 'ORIGIN_COMMENT_SAVE',
      toastr,
      payload: commentFactory({ text: this.models.origin }),
    })
  }
  this.originCommentDestroy = () => {
    root.$broadcast('CONTENT_COMMENT', {
      ...params,
      _id: this._id,
      type: 'ORIGIN_COMMENT_DESTROY',
    })
  }
  this.originCommentEdit = () => {
    root.$broadcast('CONTENT_COMMENT', {
      ...params,
      _id: this._id,
      type: 'ORIGIN_COMMENT_EDIT',
      comment: this.comments[0],
    })
  }
  this.cancelReply = () => {
    root.$broadcast('CONTENT_COMMENT', {
      ...params,
      _id: this._id,
      type: 'ORIGIN_REPLY_CANCEL',
    })
  }
  this.acceptReply = () => {
    root.$broadcast('CONTENT_COMMENT', {
      ...params,
      _id: this._id,
      type: 'ORIGIN_REPLY_ACCEPT',
      payload: commentFactory({ text: this.models.reply }),
    })
  }
  this.replyEdit = (replyIndex) => {
    root.$broadcast('CONTENT_COMMENT', {
      ...params,
      _id: this._id,
      type: 'ORIGIN_REPLY_EDIT',
      replyIndex,
      key: this.replyHashKey(this.index, replyIndex),
    })
  }
  this.replyDestroy = (replyIndex) => {
    root.$broadcast('CONTENT_COMMENT', {
      ...params,
      _id: this._id,
      type: 'ORIGIN_REPLY_DESTROY',
      replyIndex,
      storyService,
      payload: commentFactory({ text: this.models.reply }),
    })
  }
  this.cancelReplyEdit = (replyIndex) => {
    root.$broadcast('CONTENT_COMMENT', {
      ...params,
      _id: this._id,
      type: 'ORIGIN_REPLY_EDIT_CANCEL',
      replyIndex,
      payload: commentFactory({ text: this.models.reply }),
    })
  }
  this.saveReplyEdit = (replyIndex) => {
    root.$broadcast('CONTENT_COMMENT', {
      ...params,
      _id: this._id,
      type: 'ORIGIN_REPLY_EDIT_SAVE',
      replyIndex,
      storyService,
      payload: commentFactory({ text: this.models.reply }),
    })
  }
  this.originCommentAddReply = () => {
    root.$broadcast('CONTENT_COMMENT', {
      ...params,
      _id: this._id,
      type: 'ORIGIN_REPLY_ADD_INIT',
      storyService,
      payload: {
        isReplying: !this.isReplying,
      },
    })
  }
  this.clicked = ($evt) => {
    if (this.focusedComment === -1) {
      const selector = '[content-element]:nth-child(' + (this.index + 2) + ')'
      angular.element(selector).triggerHandler('focus')
      $evt.preventDefault()
    }
  }
  this.originCommentToggleReplyVisibility = () => {
    root.$broadcast('CONTENT_COMMENT', {
      ...params,
      _id: this._id,
      type: 'ORIGIN_TOGGLE_REPLIES_VISIBILITY',
    })
  }
  root.$on('CONTENT_COMMENT', (info, action) => {
    if (contentCommentReducers[action.type]) {
      contentCommentReducers[action.type].call(this, { action })
    }
  })
}
